<script setup>
import {useUsersStore} from "@/stores/players";
import {Form} from "vee-validate";
import {onMounted, ref, reactive, watch} from "vue";
import {useQuery} from "@vue/apollo-composable";
import {GET_COUNTRIES} from "@/graphql/operations/countries.ts";
import uploadService from "@/stores/upload";
import {PlusOutlined, LoadingOutlined} from '@ant-design/icons-vue';
import {message} from 'ant-design-vue';

const title = "Thông tin vận động viên";
const text = "Trang chủ";
const text1 = "Thông tin vận động viên";

import { usePlayerStore } from '@/stores/playerStore';
const playerStore = usePlayerStore();
const usersStore = useUsersStore();

const playerData = ref({...usersStore.player});
const errors = reactive({});
const fileList = ref([]);
const dataCountries = ref([]);
const loading = ref(false);
const isFileRemove = ref(false);
const fileUpload = ref("");

onMounted(() => {
  usersStore.authCheck();
  playerData.value = {...usersStore.player};
});

watch(
    () => usersStore.player,
    () => {
      playerData.value = {...usersStore.player};

      const country = playerData.value.country;
      playerData.value.country = country ? country.documentId : null;

      fileList.value = [];

      if (playerData.value.photo) {
        fileList.value.push({
          uid: playerData.value.photo.id,
          name: 'avatar',
          status: 'done',
          url: getServerResourceUrl(playerData.value.photo.url)
        });
      }
    }
)

const validateForm = () => {
  Object.keys(errors).forEach((key) => delete errors[key]);

  if (!playerData.value.first_name || playerData.value.first_name.trim() === "") {
    errors.first_name = "Họ không được để trống";
    return false;
  }

  if (!playerData.value.last_name || playerData.value.last_name.trim() === "") {
    errors.last_name = "Tên không được để trống";
    return false;
  }

  if (!playerData.value.phone || playerData.value.phone.trim() === "") {
    errors.phone = "Số điện thoại không được để trống";
    return false;
  }

  if (playerData.value.phone.length > 20) {
    errors.phone = "Số điện thoại không hợp lệ!";
    return false;
  }

  if (!playerData.value.birthday || playerData.value.birthday.trim() === "") {
    errors.birthday = "Ngày sinh không được để trống";
    return false;
  }

  if (!playerData.value.id_no || playerData.value.id_no.trim() === "") {
    errors.id_no = "CCCD/CMND không được để trống";
    return false;
  }

  if (!playerData.value.country || playerData.value.country.trim() === "") {
    errors.country = "Quốc gia không được để trống";
    return false;
  }

  return true;
};

const validateAndSubmit = async () => {
  if (validateForm()) {
    try {
      if (isFileRemove.value) {
        playerData.value.photo = null;
      }

      if (fileUpload.value) {
        playerData.value.photo = fileUpload.value;
      }

      const result = await usersStore.updateProfile(playerData.value);
      if (result.player) {
        message.success("Cập nhật thông tin thành công!");

        playerData.value = {...result.player};

        const country = playerData.value.country;
        playerData.value.country = country ? country.documentId : null;

        fileList.value = [];

        if (playerData.value.photo) {
          fileList.value.push({
            uid: playerData.value.photo.id,
            name: 'avatar',
            status: 'done',
            url: getServerResourceUrl(playerData.value.photo.url)
          });
        }

        const user = JSON.parse(localStorage.getItem('user'));
        user.player = playerData.value;
        localStorage.setItem('user', JSON.stringify(user));

        playerStore.setUser(user);

        loading.value = false;
        isFileRemove.value = false;
        fileUpload.value = null;
      } else {
        message.error("Có lỗi xảy ra khi cập nhật thông tin!");
      }
    } catch (error) {
      message.error("Có lỗi xảy ra khi cập nhật thông tin!");
      console.error(error);
    }
  }
};

const {result: resultCountries} = useQuery(
    GET_COUNTRIES,
    () => ({
      page: 1,
      pageSize: 999,
      searchFilter: '',
      sort: {},
    }),
    {fetchPolicy: 'network-only'},
);

watch(
    () => resultCountries.value?.countries_connection,
    (countries) => {
      dataCountries.value = countries?.nodes.map((country) => ({
        value: country.documentId,
        label: country.name,
      }));
    },
);

const handleUploadImage = async (formData) => {
  try {
    const result = await uploadService.uploadFile(formData);

    const res = result?.data[0];

    fileUpload.value = res.id;

    fileList.value = [
      {
        uid: res.id,
        name: res.name,
        status: 'done',
        url: getServerResourceUrl(res.url),
      },
    ];
  } catch (error) {
    console.error('Upload image failed:', error);
  }
  loading.value = false;
};

const handleChange = async (file) => {
  loading.value = true;
  if (!file) {
    loading.value = false;
    console.error('File không hợp lệ');
    message.error('File không hợp lệ');
    fileList.value = [];
    return;
  }

  if (!file.file.type || !file.file.type.startsWith('image/')) {
    loading.value = false;
    message.error('File không phải là hình ảnh!');
    fileList.value = [];
    return;
  }

  const formData = new FormData();
  formData.append('files', file.file);
  formData.append(
      'fileInfo',
      JSON.stringify({
        name: file.file.name,
        folder: null,
      }),
  );

  await handleUploadImage(formData);
};

const getServerResourceUrl = (url) => {
  const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;
  return `${BASE_URL_SERVER}${url}`;
}

function handleRemove() {
  fileList.value = [];
  isFileRemove.value = true;
  fileUpload.value = null;
}

const handlePreview = (file) => {
  const url = file.url || file.thumbUrl;
  if (url) {
    window.open(url, '_blank');
  } else {
    message.error('Không tìm thấy URL ảnh');
  }
};

</script>
<template>
  <user-header></user-header>
  <breadcrumb :text="text" :text1="text1" :title="title"/>
  <user-tabset></user-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-sidebar></settings-sidebar>

      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-group">
            <div class="card">
              <Form @submit="validateAndSubmit">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label"
                      >Họ <span class="text-danger">*</span></label
                      >
                      <input
                          id="name"
                          v-model="playerData.first_name"
                          :class="{ 'is-invalid': errors.first_name }"
                          class="form-control"
                          maxlength="255"
                          placeholder="Nhập họ"
                          type="text"
                      />
                      <div v-if="errors.first_name" class="text-danger">
                        {{ errors.first_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Tên Đệm</label>
                      <input
                          id="name"
                          v-model="playerData.middle_name"
                          class="form-control"
                          maxlength="255"
                          placeholder="Nhập tên đệm"
                          type="text"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label"
                      >Tên <span class="text-danger">*</span></label
                      >
                      <input
                          id="name"
                          v-model="playerData.last_name"
                          :class="{ 'is-invalid': errors.last_name }"
                          class="form-control"
                          maxlength="255"
                          placeholder="Nhập tên"
                          type="text"
                      />
                      <div v-if="errors.last_name" class="text-danger">
                        {{ errors.last_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-space">
                      <label class="form-label">Email</label>
                      <input id="email"
                             :value="playerData.email"
                             class="form-control"
                             disabled
                             placeholder="Vui lòng nhập email"
                             readonly
                             type="email"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Số điện thoại <span class="text-danger">*</span></label>
                      <input
                          id="phone"
                          v-model="playerData.phone"
                          :class="{ 'is-invalid': errors.phone }"
                          class="form-control"
                          maxlength="20"
                          pattern="0[0-9]{9}"
                          placeholder="Nhập số điện thoại"
                          type="text"
                      />
                      <div v-if="errors.phone" class="text-danger">
                        {{ errors.phone }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">Ngày sinh <span class="text-danger">*</span></label
                      >
                      <input
                          id="birthday"
                          v-model="playerData.birthday"
                          :class="{ 'is-invalid': errors.birthday }"
                          class="form-control"
                          placeholder="Nhập ngày sinh "
                          type="date"
                      />
                      <div v-if="errors.birthday" class="text-danger">
                        {{ errors.birthday }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="input-space">
                      <label class="form-label">CMND/CCCD <span class="text-danger">*</span></label>
                      <input
                          id="id_no"
                          v-model="playerData.id_no"
                          :class="{ 'is-invalid': errors.id_no }"
                          class="form-control"
                          placeholder="Nhập CMND/CCCD "
                          type="text"
                      />
                      <div v-if="errors.id_no" class="text-danger">
                        {{ errors.id_no }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-space">
                      <label class="form-label">Quốc gia <span class="text-danger">*</span></label>
                      <select
                          id="country"
                          v-model="playerData.country"
                          class="form-control">
                        <option v-for="item in dataCountries" :key="item.value" :value="item.value">
                          {{ item.label }}
                        </option>
                      </select>
                      <div v-if="errors.country" class="text-danger">
                        {{ errors.country }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-space">
                      <label class="form-label">Ảnh</label>
                      <a-upload
                          v-model:file-list="fileList"
                          :custom-request="handleChange"
                          :max-count="1"
                          accept="image/jpg, image/png, image/jpeg, image/webp, image/gif"
                          class="avatar-uploader"
                          list-type="picture-card"
                          name="avatar"
                          @preview="handlePreview"
                          @remove="handleRemove"
                      >
                        <loading-outlined v-if="loading"></loading-outlined>
                        <plus-outlined v-else></plus-outlined>
                        <div class="ant-upload-text">Tải ảnh lên</div>
                      </a-upload>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="input-space">
                      <label class="form-label">Tay thuận</label>
                      <a-radio-group v-model:value="playerData.play_handed" class="text-black" name="radioGroup">
                        <a-radio value="right">Tay phải</a-radio>
                        <a-radio value="left">Tay trái</a-radio>
                      </a-radio-group>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="info-about">
                      <label class="form-label" for="note"
                      >Thông tin về bạn</label
                      >
                      <textarea
                          id="note"
                          v-model="playerData.note"
                          class="form-control"
                          placeholder="Thông tin về bạn"
                          rows="3"
                      ></textarea>
                    </div>
                  </div>
                  <div class="address-form-head">
                    <h4>Địa chỉ</h4>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="input-space">
                      <label class="form-label">Địa chỉ</label>
                      <input
                          id="address"
                          v-model="playerData.address"
                          class="form-control"
                          maxlength="255"
                          placeholder="Nhập địa chỉ"
                          type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="save-changes text-end">
                  <button class="btn btn-secondary save-profile" type="submit">
                    Lưu thay đổi
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<style scoped>
form select.form-control {
  padding: 20px;
  border-radius: 10px;
  background: #FAFAFA;
  border: none;
}

form label.ant-radio-wrapper span {
  color: #000000 !important;
}
</style>
